import {Epic, ofType} from "redux-observable";
import {AppActions} from "../actions";
import {AppState} from "../AppState";
import {mergeMap, switchMap} from "rxjs/operators";
import {BuildAuthRequestFromAppState} from "../authentication/BuildAuthRequestInterface";
import {fromFetch} from "rxjs/fetch";
import ApiUrl from "../api/ApiUrl";
import {USER_P_RESET, WorkforceOnePasswordResetAction} from "../actions/WorkforceOneLoginActions";
import {EMPTY} from "rxjs";


const WorkforceOnePasswordResetRequest:  Epic<AppActions, never, AppState> = (action$, states$) => {
    return action$.pipe(
        ofType(USER_P_RESET),
        mergeMap((action: AppActions) => {
                const selectedCompany = action as WorkforceOnePasswordResetAction;
                const authDetails = BuildAuthRequestFromAppState(states$.value);
                return fromFetch(`${ApiUrl()}FFOrderClinicStatus/GetStatus`,
                    {
                        method: 'POST',
                        credentials: 'omit',
                        body: JSON.stringify(selectedCompany.payload),
                        headers: new Headers({
                            'auth_token': authDetails?.auth_token,
                            'IsMarketPlace': authDetails.IsMarketPlace,
                            'Agent': authDetails.Agent,
                            'api_version': authDetails.api_version,
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                        }),
                    })
                    .pipe(switchMap(response => response.ok ?
                        response.json() :
                        Promise.resolve(null)))
                    .pipe(switchMap(() => {
                        // it may be a good idea to toast.. api response..
                        return EMPTY;
                    }))
            }
        )
    );
};
export default WorkforceOnePasswordResetRequest;
